import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import Lightbox from 'react-images'
import { Img, FileLink } from 'containers/misc'
import { CircleLoader } from 'components/loaders'
import styles from './file-thumb.styl'
import getFileType from 'utils/getFileType'

const supportedFileTypes = [
  'doc',
  'ppt',
  'docx',
  'pptx',
  'pdf',
  'mp4',
  'xls',
  'xlsx'
]

export default class FileThumb extends Component {
  static propTypes = {
    fileUrl: PropTypes.string,
    file: PropTypes.object,
    type: PropTypes.string,
    src: PropTypes.string,
    onClick: PropTypes.func,
    formattedName: PropTypes.object,
    originUrl: PropTypes.string,
    clickable: PropTypes.bool,
    isPublic: PropTypes.bool,
    loading: PropTypes.bool,
    autodownload: PropTypes.bool,
    blobAuthCode: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
  }

  static defaultProps = {
    clickable: true,
    autocomplete: false
  }

  state = {
    isOpen: false
  }

  componentWillReceiveProps(nextProps) {
    const { autodownload, fileUrl } = this.props
    const type = getFileType(nextProps.originUrl)

    if (
      autodownload &&
      get(nextProps, 'file.fileLocalUrl') &&
      fileUrl !== nextProps.fileUrl
    ) {
      if (supportedFileTypes.some(item => item === type)) {
        this.props.onClick(nextProps.fileUrl, type, nextProps.file)
      }
    }
  }

  handleOpenLightbox = () => {
    this.setState({
      isOpen: true
    })
  }

  handleCloseLightbox = () => {
    this.setState({
      isOpen: false
    })
  }

  render() {
    const {
      fileUrl,
      type,
      clickable,
      loading,
      formattedName,
      autodownload,
      file,
      isPublic,
      src,
      blobAuthCode
    } = this.props
    const { isOpen } = this.state
    let content = (
      <img src={fileUrl} width={100} onClick={this.handleOpenLightbox} />
    )

    if (!fileUrl && !loading && !isPublic) {
      return null
    }

    if (!autodownload && supportedFileTypes.some(item => item === type)) {
      content = (
        <span
          onClick={() => clickable && this.props.onClick(fileUrl, type, file)}
        >
          <span
            className={`ico ico--file ${styles.ico} ${clickable ? styles.clickable : ''}`}
          />
          <span className={styles.type}>{formattedName || type}</span>
        </span>
      )
    }

    if (autodownload) {
      content = formattedName
    }

    let isImage = false

    if (type) {
      isImage =
        type.toLowerCase() === 'jpeg' ||
        type.toLowerCase() === 'png' ||
        type.toLowerCase() === 'jpg'
    }

    if (isPublic || blobAuthCode) {
      if (isImage) {
        content = <Img src={src} asGallery defaultWidth={1000} />
      } else {
        content = (
          <FileLink
            src={src}
            type={type}
            icoClass={styles.ico}
            typeClass={styles.type}
          />
        )
      }
    }

    return (
      <span className={styles.thumb}>
        {loading && <CircleLoader size={30} inline />}
        {isPublic && content}
        {!loading &&
          !isPublic &&
          <span>
            {content}
            {fileUrl &&
              isImage &&
              <Lightbox
                images={[{ src: fileUrl }]}
                isOpen={isOpen}
                onClose={this.handleCloseLightbox}
                showImageCount={false}
              />}
          </span>}
      </span>
    )
  }
}
